export function clearUsernamePassword() {
  saveUsernamePassword(null, null);
}

export function saveUsernamePassword(username: string | null, password: string | null) {
  if (!window.platformSecureStore && !window.flutter_inappwebview) {
    return;
  }
  const loginAutocompleteMessage = {
    username,
    password,
  };
  const message = JSON.stringify(loginAutocompleteMessage);
  if (window.platformInformation) {
    window.platformSecureStore.postMessage(message);
  }
  if (window.flutter_inappwebview) {
    window.flutter_inappwebview.callHandler('platformSecureStore', message);
  }
}
